import NomenclatureListPage from "../../../common/nomenclatures/NomenclatureListPage";
import { endpointsMetadata } from "../../../common/infrastructure/routes/endpointsMetadata";
import {
  baseNomenclatureDefaults,
  baseNomenclatureSchema,
  IBaseNomenclatureInputModel,
} from "../../../common/nomenclatures/models/baseNomenclatureInputModel";
import { DefaultInputField } from "../../../common/components/forms/inputs/InputField/DefaultInputField";
import { nameof } from "ts-simple-nameof";
import { NomenclatureListPageBaseItem } from "../../../common/nomenclatures/components/NomenclatureListPageBaseItem";

export const StudioPlanTypesNomenclature = () => {
  return (
    <NomenclatureListPage<
      IBaseNomenclatureInputModel,
      IBaseNomenclatureInputModel
    >
      endpoints={endpointsMetadata.studioPlanTypesNomenclature}
      title={"Типове планове"}
      dialogAddTitle="Добавяне на нов тип план"
      dialogEditTitle="Редактиране на тип план"
      emptyListText={"В момента нямате добавени типове планове"}
      editOnRowClick
      itemTemplate={(item, index, isLoading, actionButtons, className) => (
        <NomenclatureListPageBaseItem
          item={item}
          isLoading={isLoading}
          actionButtons={actionButtons}
          className={className}
        />
      )}
      formSchema={baseNomenclatureSchema}
      defaultValues={() => baseNomenclatureDefaults}
      formFields={
        <DefaultInputField
          name={nameof<IBaseNomenclatureInputModel>((x) => x.name)}
          label="Тип на план"
          placeholder={"Йога"}
        />
      }
    />
  );
};
